export const REVENUE_CHANGE_TYPES = [
  {
    label: `Any`,
    value: `any`,
  },
  {
    label: `New`,
    value: `new`,
  },
  {
    label: `Upsell`,
    value: `upgrade`,
  },
  {
    label: `Downgrade`,
    value: `downgrade`,
  },
  {
    label: `Churn`,
    value: `churn`,
  },
  {
    label: `Flat`,
    value: `flat`,
  },
];
